import {createSlice} from '@reduxjs/toolkit';

export const disclaimer = createSlice({
    name: 'disclaimerPopUp',
    initialState: {
        disclaimerSigned:  true,
    },
    reducers: {
 
        updateState: (state, action) => {
            state.disclaimerSigned = action.payload.disclaimerSigned;
        },

        // updateSelectedOffice: (state, action) => {
        //     state.officeId = action.payload.officeId;
        //     state.officeName = action.payload.officeName;
        // }
    },
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = apiPath.actions
export const { updateState } = disclaimer.actions
export default disclaimer.reducer